import messages from './data/messages.js'

export default defineI18nConfig(() => {
  const config = useRuntimeConfig()
  const locale = config?.public?.locale || 'en'

  return {
    legacy: false,
    locale: locale,
    defaultLocale: locale,
    messages: messages,
  }
})